import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';

interface PreviewUrlResponse {
  previewUrl: string;
  expiresAt?: string;
}

/**
 * Render a DMS document as an <img>. Fetches a signed preview URL on mount.
 * The underlying endpoint returns a short-lived signed GCS URL.
 */
export function DmsImage({
  documentId,
  alt,
  className,
}: {
  documentId: string;
  alt?: string;
  className?: string;
}) {
  const { data, isLoading, error } = useQuery({
    queryKey: ['dms', 'preview-url', documentId],
    queryFn: () => api.get<PreviewUrlResponse>(`/v4/dms/documents/${documentId}/preview-url`),
    staleTime: 4 * 60 * 1000,
  });

  if (isLoading) {
    return <div className={`bg-slate-100 animate-pulse ${className ?? ''}`} />;
  }
  if (error || !data?.previewUrl) {
    return (
      <div className={`flex items-center justify-center bg-slate-100 text-slate-400 text-xs ${className ?? ''}`}>
        No preview
      </div>
    );
  }
  return <img src={data.previewUrl} alt={alt ?? ''} className={className} loading="lazy" />;
}
